import { useEffect, useState } from "react";

export const useUSPhoneValidation = (phone: string) => {
  const [isValid, setIsValid] = useState(true);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!touched) return;

    let timer: NodeJS.Timeout;

    if (phone.trim() !== "") {
      timer = setTimeout(() => {
        const valid = /^\d{10}$/.test(phone);
        setIsValid(valid);
      }, 500);
    } else {
      setIsValid(true);
    }

    return () => clearTimeout(timer);
  }, [phone, touched]);

  return {
    isValid,
    touched,
    setTouched,
  };
};